<!-- 电站概况 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <div
        v-loading="queryLoading"
        class="energy-home"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-card class="box-card" style="grid-row: span 2;">
          <template #header>
            {{ $t('text.dlgl') }}
          </template>
          <template #default>
            <svg-image :data="power.data" style="margin:0 auto;width:100%" />
          </template>
        </el-card>
        <el-card class="box-card" style="grid-row: span 2;">
          <template #header>
            {{ $t('text.nlph') }}
          </template>
          <template #default>
            <line-chart
              :data="balance.data"
              :columns="balance.columns"
              :setting="balance.setting"
              :extend="balance.extend"
              :format="balance.format"
              :unit="balance.unit"
            />
          </template>
        </el-card>
        <el-card class="box-card" style="grid-row: span 2;">
          <template #header>
            {{ $t('text.sbzt') }}
          </template>
          <template #default>
            <ring-chart
              :data="status.data"
              :columns="status.columns"
              :setting="status.setting"
              :extend="status.extend"
            />
          </template>
        </el-card>
        <el-card class="box-card income-card">
          <template #header>
            {{ $t('text.sy') }}
          </template>
          <template #default>
            <el-carousel indicator-position="outside" height="calc(100% - 32px)" arrow="never">
              <el-carousel-item>
                <h3>{{ $t('text.rsr') }}</h3>
                <p>{{ station | objValue('dayIncome') }}{{ $t('text.yuan') }}</p>
              </el-carousel-item>
              <el-carousel-item>
                <h3>{{ $t('text.ysr') }}</h3>
                <p>{{ station | objValue('monthIncome') }}{{ $t('text.yuan') }}</p>
              </el-carousel-item>
              <el-carousel-item>
                <h3>{{ $t('text.nsr') }}</h3>
                <p>{{ station | objValue('yearIncome') }}{{ $t('text.yuan') }}</p>
              </el-carousel-item>
              <el-carousel-item>
                <h3>{{ $t('text.zsr') }}</h3>
                <p>{{ station | objValue('totalIncome') }}{{ $t('text.yuan') }}</p>
              </el-carousel-item>
            </el-carousel>
          </template>
        </el-card>
        <el-card class="box-card">
          <template #header>
            {{ $t('text.zjrl') }}
          </template>
          <template #default>
            <div style="width: 100%;height: 100%;box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: white;font-size: large;">
              <span>{{ station | objValue('capacity') }}kWp</span>
            </div>
          </template>
        </el-card>
        <el-card class="box-card">
          <template #header>
            {{ $t('text.rdl') }}
          </template>
          <template #default>
            <div style="width: 100%;height: 100%;box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: white;font-size: large;">
              <p>{{ station.ymdEnergys|objValue(['dayEnergy','f', 'cvalue'], 0) }}<span>{{ station.ymdEnergys|objValue(['dayEnergy', 'f','cvalue'], 1) }}</span></p>
            </div>
          </template>
        </el-card>
        <el-card class="box-card surplus-card">
          <template #header>
            {{ $t('text.jygj') }}
          </template>
          <template #default>
            <el-carousel indicator-position="outside" height="calc(100% - 32px)" arrow="never">
              <el-carousel-item>
                <p>{{ station | objValue('safeTrees') }}{{ $t('text.ks') }}</p>
              </el-carousel-item>
              <el-carousel-item>
                <p>{{ station | objValue('safeCO2') }}t {{ $t('text.jp') }}</p>
              </el-carousel-item>
            </el-carousel>
          </template>
        </el-card>
        <el-card class="box-card">
          <template #header>
            {{ $t('text.ndl') }}
          </template>
          <template #default>
            <div style="width: 100%;height: 100%;box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: white;font-size: large;">
              <p>{{ station.ymdEnergys|objValue(['yearEnergy', 'f','cvalue'], 0) }}<span>{{ station.ymdEnergys|objValue(['yearEnergy', 'f','cvalue'], 1) }}</span></p>
            </div>
          </template>
        </el-card>
        <el-card class="box-card">
          <template #header>
            {{ $t('text.zdl') }}
          </template>
          <template #default>
            <div style="width: 100%;height: 100%;box-sizing: border-box;display: flex;align-items: center;justify-content: center;color: white;font-size: large;">
              <p>{{ station.ymdEnergys|objValue(['totalEnergy','f', 'cvalue'], 0) }}<span>{{ station.ymdEnergys|objValue(['totalEnergy','f', 'cvalue'], 1) }}</span></p>
            </div>
          </template>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import SvgImage from '@views/Svg'
import RingChart from '@views/Charts/RingChart'
import LineChart from '@views/Charts/LineChart'
import { GetStationOverviewData } from '@apis/Statistics'
export default {
  components: {
    SvgImage,
    RingChart,
    LineChart
  },
  data () {
    return {
      // 查询加载中
      queryLoading: false,
      station: {}, // 电站数据
      // 地图
      map: {
        lat: this.$store.getters.station.lat,
        lng: this.$store.getters.station.lng
      },
      // 功率
      power: {
        data: {
          nPower: 0,
          fPower: 0,
          pPower: 0,
          bSoc: 0,
          capacity: 1
        }
      },
      // 能量平衡
      balance: {
        data: [],
        columns: ['time', 'val1', 'val2', 'val3'],
        setting: { labelMap: { val1: this.$t('text.wcgl'), val2: this.$t('text.fzgl'), val3: this.$t('text.fdgl') }},
        format: ['hh:mm'],
        unit: 'w',
        extend: {
          grid: {
            right: 30,
            left: 30,
            bottom: 10,
            top: 30
          },
          yAxis: {
            name: 'W',
            position: 'left'
          },
          legend: {
            show: false
          }
        }
      },
      // 设备状态
      status: {
        data: [{
          type: this.$t('text.zx'),
          value: '0'
        }, {
          type: this.$t('text.lx'),
          value: '0'
        }, {
          type: this.$t('text.bj'),
          value: '0'
        }],
        columns: ['type', 'value'],
        setting: {
          radius: [70, 90],
          offsetY: 130,
          label: {
            show: true,
            formatter: '{c}',
            color: '#FFFFFF'
          },
          roseType: 'radius',
          labelLine: {
            show: true
          }
        },
        extend: {
          color: ['#50b0ff', '#1ec9e4', '#ffb945'],
          legend: {
            show: true,
            bottom: 30,
            itemGap: 40,
            icon: 'circle',
            textStyle: {
              color: '#FFFFFF'
            }
          }
        }
      }
    }
  },
  created () {
    this.getStationData()
  },
  methods: {
    // 获取电站数据
    getStationData () {
      this.queryLoading = true
      GetStationOverviewData({
        id: this.$store.getters.station.id
      }).then(res => {
        this.station = res.data
        this.balance.data = res.data.balance || []
        this.power.data = res.data.mPower
        this.$set(this.power.data, 'capacity', res.data.capacity)
        this.status.data[0].value = res.data.deviceStatus.onlines
        this.status.data[1].value = res.data.deviceStatus.offlines
        this.status.data[2].value = res.data.deviceStatus.alarms
      }).then(() => {
        this.queryLoading = false
      }).catch(() => {
        this.queryLoading = false
        this.$message({
          message: '获取电站数据失败',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style scoped>
.energy-home {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-template-rows: repeat(4,1fr);
  grid-gap: 12px;
}

.energy-home .box-card{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.energy-home .box-card >>> .el-card__header{
  width: 100%;
  height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: white;
  border-bottom: none;
}
.energy-home .box-card >>> .el-card__header::before{
  display: block;
  content: '';
  width: 5px;
  height: 25px;
  border-radius: 5px;
  background-color: var(--primary-color);
  margin-right: 10px;
}

.energy-home .box-card >>> .el-card__body{
  width: 100%;
  height: calc(100% - 40px);
  padding: 15px;
  box-sizing: border-box;
}

.energy-home .income-card >>> .el-card__body .el-carousel{
  height: 100%;
}
.energy-home .income-card >>> .el-card__body .el-carousel h3,
.energy-home .income-card >>> .el-card__body .el-carousel p{
  color: white;
  text-align: center;
  font-size: larger;
  font-weight: bold;
}

.energy-home .surplus-card >>> .el-card__body .el-carousel{
  height: 100%;
}
.energy-home .surplus-card >>> .el-card__body .el-carousel h3,
.energy-home .surplus-card >>> .el-card__body .el-carousel p{
  color: white;
  text-align: center;
  font-size: larger;
  font-weight: bold;
}

</style>

